/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import IconButton from "../../common/IconButton";
import Table from "../../common/Table";
import Body from "../../components/Body";
import TableMenu from "../../components/TableMenu";
import AppModal from "../../common/AppModal";
import CreateEmployeeModel from "./CreateEmployeeModel";
import config from "../../config/config";
import AppButton from "../../common/AppButton";
import useHeader from "../../hooks/useHeader";
import EmployeePaySalary from "./EmployeePaySalary";
import EmployeeSalaryHistorymodel from "./EmployeeSalaryHistorymodel";
import EmployeeViewModel from "./EmployeeViewModel";
import { observer } from "mobx-react-lite";
import { BiPlus, BiTask } from "react-icons/bi";
import { FaAmazonPay, FaEye } from "react-icons/fa";
import { VscHistory } from "react-icons/vsc";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { cloneDeep } from "lodash";
import { getEmployees } from "../../stores/EmployeeStore";
import { useQuery } from "@tanstack/react-query";

const header = [
  { title: "Employee ID", name: "employeeId" },
  { title: "Name", name: "name", filter: "Search" },
  { title: "Contact", name: "contact" },
  { title: "Type", name: "type", filter: "Select" },
];

function EmployeesList() {
  const navigate = useNavigate();
  const location = useLocation();

  const [model, setModel] = useState({});
  const Employee = CreateEmployeeModel();
  const { pathname } = location;
  const { setHeader } = useHeader();

  const { data, isLoading, isError } = useQuery({
    queryFn: () => getEmployees(),
    queryKey: ["employees"],
  });

  const handleClick = (data) => {
    navigate(`${pathname}/${data._id}`, { state: { data: cloneDeep(data) } });
  };

  const PaySalary = EmployeePaySalary();
  const PayHistory = EmployeeSalaryHistorymodel();
  const Emp = EmployeeViewModel();

  return (
    <Body noPadding>
      <TableMenu style={{ justifyContent: "flex-end" }}>
        <IconButton
          onClick={() => {
            setModel({
              header: <Employee.Header />,
              body: (
                <Employee.Body
                  onDone={() => {
                    setModel({});
                  }}
                />
              ),
              footer: <Employee.Footer />,
              visible: true,
            });
          }}
          icon={<BiPlus size={35} />}
        />
      </TableMenu>
      {isError && (
        <div className="alert alert-danger m-3">
          Failed to load employees. Please try again later.
        </div>
      )}
      <Table
        sideButtonStyle={{ minWidth: 100 }}
        sortable
        loading={isLoading}
        header={header}
        data={data}
        SideButtons={({ inv }) => {
          return (
            <div className="side-button">
              <AppButton
                tooltip="Tasks"
                onClick={() => {
                  handleClick(inv);
                }}
                className="text-primary btn-light"
                leftIcon={<BiTask size={20} />}
              />
              <AppButton
                tooltip="Pay salary"
                onClick={() => {
                  setModel({
                    visible: true,
                    model: (
                      <PaySalary.Body
                        employee={inv}
                        onDone={() => {
                          setModel({});
                        }}
                      />
                    ),
                  });
                }}
                className="text-primary btn-light"
                leftIcon={<FaAmazonPay size={config.iconSize} />}
              />
              <AppButton
                tooltip="Payments Log"
                onClick={() => {
                  setModel({
                    visible: true,
                    header: <PayHistory.Header employee={inv} />,
                    body: (
                      <PayHistory.Body
                        onDone={() => {
                          setModel({});
                        }}
                        setModel={setModel}
                        employee={inv}
                      />
                    ),
                  });
                }}
                className="text-primary btn-light"
                leftIcon={<VscHistory size={18} />}
              />

              <AppButton
                tooltip="Details"
                onClick={() => {
                  setModel({
                    visible: true,
                    model: (
                      <Emp.Body
                        employee={inv}
                        onDone={() => {
                          setModel({});
                        }}
                      />
                    ),
                  });
                }}
                className="text-primary btn-light"
                leftIcon={<FaEye size={18} />}
              />
            </div>
          );
        }}
      />

      <AppModal
        {...model}
        onHide={() => {
          setModel({});
        }}
      />
    </Body>
  );
}
export default observer(EmployeesList);
